/**
 * Setup search offcanvas functionality
 */
export default function setupOffcanvasSearchUI() {
  const searchButton = document.getElementById("header-search-button");
  const searchOffcanvas = document.querySelector(".search-offcanvas");
  const closeSearchButton = document.querySelector(".close-search");
  const offcanvasSearchForm = document.getElementById("offcanvas-search-form");
  const offcanvasSearchInput = document.getElementById(
    "offcanvas-search-input"
  );
  const viewAllResultsButton = document.querySelector(".view-all-results");

  // Get the main shared overlay element used by other offcanvas components
  const mainOverlay = document.querySelector(".overlay");

  // Toggle search offcanvas on button click
  if (searchButton && searchOffcanvas) {
    searchButton.addEventListener("click", function (e) {
      e.preventDefault();
      openSearchOffcanvas();
    });
  }

  // Close search offcanvas
  if (closeSearchButton && searchOffcanvas) {
    closeSearchButton.addEventListener("click", closeSearchOffcanvas);
  }

  // Close search offcanvas when clicking on overlay
  if (mainOverlay) {
    mainOverlay.addEventListener("click", function (e) {
      // Only close if the search offcanvas is currently showing
      if (searchOffcanvas.classList.contains("show")) {
        closeSearchOffcanvas();
      }
    });
  }

  // Function to open search offcanvas
  function openSearchOffcanvas() {
    searchOffcanvas.classList.remove("hide");
    searchOffcanvas.classList.add("show");

    // Show the main overlay
    if (mainOverlay) {
      mainOverlay.classList.remove("hide");
      mainOverlay.classList.add("show");
    }

    // Prevent body scrolling
    document.body.style.overflow = "hidden";

    // Focus the search input after transition
    setTimeout(() => {
      if (offcanvasSearchInput) {
        offcanvasSearchInput.focus();
      }
    }, 300);
  }

  // Function to close search offcanvas
  function closeSearchOffcanvas() {
    searchOffcanvas.classList.remove("show");
    searchOffcanvas.classList.add("hide");

    // Hide the main overlay (only if no other offcanvas is open)
    if (mainOverlay && !isAnyOtherOffcanvasOpen()) {
      mainOverlay.classList.remove("show");
      mainOverlay.classList.add("hide");
    }

    // Restore body scrolling
    document.body.style.overflow = "";
  }

  // Helper function to check if any other offcanvas is open
  function isAnyOtherOffcanvasOpen() {
    const cartOffcanvas = document.querySelector(".cart-offcanvas");
    const favoritesOffcanvas = document.querySelector(".favorites-offcanvas");
    const loginOffcanvas = document.querySelector(".login-offcanvas");

    return (
      (cartOffcanvas && cartOffcanvas.classList.contains("show")) ||
      (favoritesOffcanvas && favoritesOffcanvas.classList.contains("show")) ||
      (loginOffcanvas && loginOffcanvas.classList.contains("show"))
    );
  }

  // Handle search form submission
  if (offcanvasSearchForm && offcanvasSearchInput) {
    offcanvasSearchForm.addEventListener("submit", function (e) {
      const query = offcanvasSearchInput.value.trim();
      if (query.length < 3) {
        e.preventDefault();
        alert(
          searchVars.messages.minChars || "Please enter at least 3 characters"
        );
      }
    });
  }

  // Update "View All Results" button href when searching
  if (viewAllResultsButton && offcanvasSearchInput && offcanvasSearchForm) {
    offcanvasSearchInput.addEventListener("input", function () {
      const query = offcanvasSearchInput.value.trim();
      if (query.length >= 3) {
        const shopUrl = new URL(offcanvasSearchForm.action);
        shopUrl.searchParams.set("search", query);
        viewAllResultsButton.href = shopUrl.toString();
      }
    });
  }

  // Setup async search functionality
  setupAsyncSearch();
}

/**
 * Setup asynchronous search functionality
 */
function setupAsyncSearch() {
  const offcanvasSearchInput = document.getElementById(
    "offcanvas-search-input"
  );
  const searchResultsList = document.querySelector(".search-results-list");
  const resultsCount = document.querySelector(".results-count");
  const initialState = document.querySelector(".search-initial-state");
  const loadingState = document.querySelector(".search-loading");
  const noResultsState = document.querySelector(".search-no-results");
  const resultsWrapper = document.querySelector(".search-results-wrapper");

  if (!offcanvasSearchInput || !searchResultsList) return;

  let searchTimeout = null;

  offcanvasSearchInput.addEventListener("input", function () {
    const query = offcanvasSearchInput.value.trim();

    // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Hide all states and show loading if query is valid
    if (query.length >= 3) {
      initialState.classList.add("hide");
      noResultsState.classList.add("hide");
      resultsWrapper.classList.add("hide");
      loadingState.classList.remove("hide");

      // Set timeout for search to avoid excessive requests
      searchTimeout = setTimeout(() => {
        performAsyncSearch(query);
      }, 300);
    } else {
      // Show initial state if query is too short
      initialState.classList.remove("hide");
      loadingState.classList.add("hide");
      noResultsState.classList.add("hide");
      resultsWrapper.classList.add("hide");
    }
  });

  /**
   * Perform async search request
   * @param {string} query - Search query
   */
  function performAsyncSearch(query) {
    // Set up the URL for the AJAX request
    const ajaxUrl = searchVars.ajaxUrl || "/wp-admin/admin-ajax.php";
    const url = new URL(ajaxUrl, window.location.origin);

    // Add parameters
    url.searchParams.append("action", "async_product_search");
    url.searchParams.append("query", query);

    // Make the request
    fetch(url.toString())
      .then((response) => response.json())
      .then((data) => {
        // Hide loading state
        loadingState.classList.add("hide");

        if (data.success && data.data.count > 0) {
          // Show results
          displaySearchResults(data.data);
          resultsWrapper.classList.remove("hide");
          noResultsState.classList.add("hide");
        } else {
          // Show no results
          resultsWrapper.classList.add("hide");
          noResultsState.classList.remove("hide");
        }
      })
      .catch((error) => {
        console.error("Search error:", error);
        loadingState.classList.add("hide");
        noResultsState.classList.remove("hide");
        resultsWrapper.classList.add("hide");
      });
  }

  /**
   * Display search results in the offcanvas
   * @param {Object} data - Search results data
   */
  function displaySearchResults(data) {
    // Update results count
    resultsCount.textContent = `${data.count} ${
      data.count === 1
        ? searchVars.messages.resultSingular
        : searchVars.messages.resultPlural
    }`;

    // Clear previous results
    searchResultsList.innerHTML = "";

    // Add new results
    data.items.forEach((item) => {
      const resultItem = document.createElement("a");
      resultItem.href = item.url;
      resultItem.classList.add("search-result-item");

      let categoryHTML = "";
      if (item.category) {
        categoryHTML = `<div class="item-category">${item.category}</div>`;
      }

      resultItem.innerHTML = `
        <div class="item-image">
          <img src="${item.image}" alt="${item.title}">
        </div>
        <div class="item-details">
          <h4>${item.title}</h4>
          ${categoryHTML}
          <div class="item-price">${item.price}</div>
        </div>
      `;

      searchResultsList.appendChild(resultItem);
    });
  }
}
